import { del, post } from '@common/Http';
import { get as getFromLs, set as setToLS } from '@helpers/localStorage';
import { API_FAVORITE_BRAND_ADD, API_FAVORITE_BRAND_REMOVE } from '@routes';

const listeners = {};
const cache = [];

const updateSessionStorage = (response) => {
    const key = 'favoriteBrandJSON';
    let record = getFromLs(key);

    if (record) {
        record = JSON.parse(record);

        if (record.key !== undefined) {
            setToLS(key, JSON.stringify({
                key: record.key,
                ...response
            }));
        }
    }
};

export const add = (brandId, gender, name, brandAzId) => post(
    API_FAVORITE_BRAND_ADD, {
        brandId, gender, name, brandaz_id: brandAzId
    }
).then(updateSessionStorage);

export const remove = (brandId, gender, name, brandAzId) => del(
    API_FAVORITE_BRAND_REMOVE, {
        brandId, gender, name, brandaz_id: brandAzId
    }
).then(updateSessionStorage);

// TODO Everything below should be replaced with after
// favorite brands rewrite to react T42367

export const storeInCache = (brandId) => {
    if (cache.includes(brandId)) {
        cache.splice(cache.indexOf(brandId), 1);
    } else {
        cache.push(brandId);
    }
};

export const existsInCache = brandId => cache.includes(brandId);

export const sendToComponent = (name, payload) => {
    if (listeners[name] !== undefined) {
        for (const callback of listeners[name]) {
            callback(payload);
        }
    }
};

export const listenForChanges = (name, callback) => {
    if (listeners[name] === undefined) {
        listeners[name] = [];
    }

    listeners[name].push(callback);
};
